import { Config, fetchJSON, Languages } from '@ratehub/base-ui';


/**
 * returns API response data for the given card
 * @param {Object} params
 * @param {string} [params.slug] the target card’s slug
 * @param {number} [params.id] the target card’s id (only one of slug or id is required)
 * @param {Object} [params.monthlySpending] categorized monthly spending amounts
 * @param {string} [params.language=en] en | fr
 * @param {string} [params.province] the province code (e.g. ON)
 * @param {boolean} [params.isDraftMode] returns the latest draft version of the card
 * @param {Object} abortControllerSignal an AbortSignal object instance to cancel ongoing fetch request 
 * @returns {Promise<Object>}
 */
async function fetchCreditCard({
    slug,
    id,
    monthlySpending,
    language = Languages.ENGLISH,
    province,
    isDraftMode,
}, abortControllerSignal) {
    const json = await fetchJSON({
        url: Config.CC_API_URL + '/card',
        options: {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },

            body: JSON.stringify({
                id: slug || id,
                language,
                'rh-draftmode': isDraftMode,
                province,
                ...(monthlySpending && { spendingProfile: monthlySpending }),
            }),
        },
        signal: abortControllerSignal,
    }, 'fetchCreditCard');

    if (!json?.data?.creditCard) {
        // eslint-disable-next-line no-console
        console.error(`fetchCreditCard: Could not fetch credit card ${slug || id}`);

        return {};
    }

    return json.data.creditCard;
}

export default fetchCreditCard;
